<div class="wrapper overflow-y-auto">
    <div class="mb-4 bg-white shadow-md" *ngIf="(isLoading$ | async) === false">
        <h1
            class="p-4 text-left text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow"
            *ngIf="zone?.destination === null; else fromAToB">
            {{ 'TICKET_SUMMARY_V2_ZONE' | translate }}:
            {{ zone?.origin?.name | translateObjectField: null : currentLanguage }}
        </h1>
        <ng-template #fromAToB>
            <div
                class="grid grid-cols-[auto_1fr] grid-rows-2 gap-x-4 border-b border-solid border-black border-opacity-10 p-4 dark:border-contrast-yellow">
                <!-- Icons column -->
                <div class="row-span-2 flex flex-col items-center justify-center py-1" aria-disabled="true">
                    <div class="flex h-6 w-6 flex-shrink-0 items-center justify-center">
                        <ion-icon
                            class="orb-app-light:text-grey-zambezy text-old_silver h-full w-full dark:text-contrast-yellow"
                            src="{{ assetsPath$ | async }}/img/purchase-flow-v2/product-area/origin.svg"></ion-icon>
                    </div>
                    <div class="flex h-4 w-6 flex-shrink-0 items-center justify-center">
                        <ion-icon
                            class="orb-app-light:text-grey-zambezy text-old_silver h-full w-full dark:text-contrast-yellow"
                            src="{{
                                assetsPath$ | async
                            }}/img/purchase-flow-v2/product-area/connection_dots.svg"></ion-icon>
                    </div>
                    <div class="flex h-6 w-6 flex-shrink-0 items-center justify-center">
                        <ion-icon
                            class="orb-app-light:text-grey-zambezy text-old_silver h-full w-full dark:text-contrast-yellow"
                            src="{{
                                assetsPath$ | async
                            }}/img/purchase-flow-v2/product-area/destination.svg"></ion-icon>
                    </div>
                </div>
                <div class="row-span-2 flex flex-col gap-y-4 py-1">
                    <!-- Origin text -->
                    <div class="flex items-center text-left text-base">
                        <div class="min-w-0 flex-1">
                            <ng-container *ngIf="isStringName(zone?.origin?.name); else translateOrigin">
                                <ng-container [ngSwitch]="zone?.origin?.name">
                                    <span *ngSwitchCase="'LOCATION_FROM_MAP'">{{
                                        'LOCATION_FROM_MAP' | translate
                                    }}</span>
                                    <span *ngSwitchCase="'CURRENT_LOCATION'">{{ 'CURRENT_LOCATION' | translate }}</span>
                                    <span *ngSwitchDefault>{{ zone?.origin?.name }}</span>
                                </ng-container>
                            </ng-container>
                            <ng-template #translateOrigin>
                                {{ zone?.origin?.name }}
                            </ng-template>
                            <span
                                *ngIf="
                                    env.JOURNEY_PLANNER?.SHOW_MUNICIPALITY_IN_STOP_NAME &&
                                    zone?.origin?.municipalityName
                                ">
                                ({{ zone.origin.municipalityName }})</span
                            >
                        </div>
                    </div>
                    <!-- Destination text -->
                    <div class="flex items-center text-left text-base">
                        <div class="min-w-0 flex-1">
                            <ng-container *ngIf="isStringName(zone?.destination?.name); else translateDestination">
                                <ng-container [ngSwitch]="zone?.destination?.name">
                                    <span *ngSwitchCase="'LOCATION_FROM_MAP'">{{
                                        'LOCATION_FROM_MAP' | translate
                                    }}</span>
                                    <span *ngSwitchCase="'CURRENT_LOCATION'">{{ 'CURRENT_LOCATION' | translate }}</span>
                                    <span *ngSwitchDefault>{{ zone?.destination?.name }}</span>
                                </ng-container>
                            </ng-container>
                            <ng-template #translateDestination>
                                {{ zone?.destination?.name }}
                            </ng-template>
                            <span
                                *ngIf="
                                    env.JOURNEY_PLANNER?.SHOW_MUNICIPALITY_IN_STOP_NAME &&
                                    zone?.destination?.municipalityName
                                ">
                                ({{ zone.destination.municipalityName }})</span
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div class="pb-3 pl-4 pr-4 pt-4 text-grey-dark dark:text-contrast-yellow" *ngIf="showZone">
                {{ zones }} {{ 'ZONES' | translate }}
            </div>
        </ng-template>
    </div>
    <div class="flex-center flex" *ngIf="env.IS_NEW_AFC && productsGroups.length === 0">
        {{ 'TICKETS_EMPTY_RESULT' | translate }}:
    </div>
    <div class="mb-4 bg-white px-4 shadow-md" *ngFor="let productGroup of productsGroups; let index = index">
        <!-- For non-new AFC -->
        <ng-container *ngIf="!env.IS_NEW_AFC">
            <ng-container *ngIf="productGroup.products.length">
                <ng-container
                    *ngTemplateOutlet="
                        productTemplate;
                        context: { group: productGroup, product: productGroup.products[0] }
                    ">
                </ng-container>
            </ng-container>
            <button
                class="product flex-justify-between flex w-full gap-4 border-t border-solid border-black border-opacity-10 pb-4 pt-4 dark:border-contrast-yellow"
                *ngFor="let product of productGroup.products"
                (click)="presentModal(product.id, productGroup.code)">
                <ion-icon
                    class="varmland-light:text-secondary-button orebro-light:text-orange-500 h-8 w-8 text-secondary dark:filter-yellow"
                    aria-label="icon-product-{{ product.name }}"
                    src="{{ assetsPath$ | async }}/img/purchase-flow-v2/products/{{
                        productGroup.code.toLowerCase()
                    }}.svg"></ion-icon>
                <div class="product-info flex-1">
                    <div class="flex-align-center flex justify-between">
                        <p class="product-info__name text-base font-bold leading-5 dark:text-contrast-yellow">
                            {{ product.name | translateObjectField: 'translation' : translate.currentLang }}
                        </p>
                        <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                            <span *ngIf="product?.price">
                                {{ product.price.amount | moneyFormat }}
                                {{ product.price.currency || currency }}
                            </span>
                        </p>
                    </div>
                    <p
                        class="pt-2 text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow"
                        *ngIf="product.description && !hideDescription">
                        {{ product.description | translateObjectField: 'translation' : translate.currentLang }}
                    </p>
                    <div
                        class="flex-align-center flex justify-between"
                        *ngIf="
                            (env.PURCHASE_FLOW?.SHOW_TICKET_DURATION_DESCRIPTION &&
                                productGroup.code === ProductCode.SINGLE) ||
                            productGroup.code === ProductCode.MULTI_JOURNEY
                        ">
                        <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                            <span>
                                {{
                                    ticketDurationDescriptionService.getProductDurationDescription(
                                        product.products[0].activeTicketDurationInMinutes
                                    )
                                }}
                            </span>
                        </p>
                    </div>
                </div>
                <div class="flex flex-col justify-center p-2">
                    <ion-icon name="chevron-forward-outline" aria-hidden="true"></ion-icon>
                </div>
            </button>
        </ng-container>

        <!-- New AFC product type blocks -->
        <div *ngIf="productTypeSelectionsIsLoading === false">
            <ng-container *ngIf="env.IS_NEW_AFC" [ngSwitch]="productGroup.code">
                <!-- SINGLE_TICKET block -->
                <ng-container *ngSwitchCase="ProductCode.SINGLE_TICKET">
                    <ng-container *ngIf="productGroup.products.length">
                        <ng-container
                            *ngTemplateOutlet="
                                productTemplate;
                                context: { group: productGroup, product: productGroup.products[0] }
                            ">
                        </ng-container>
                    </ng-container>
                    <button
                        class="product flex-justify-between flex w-full gap-4 border-t border-solid border-black border-opacity-10 pb-4 pt-4 dark:border-contrast-yellow"
                        *ngFor="let product of productGroup.products"
                        [attr.aria-label]="product.ariaLabel"
                        (click)="presentModal(product.id, productGroup.code)">
                        <ion-icon
                            class="varmland-light:text-secondary-button orebro-light:text-orange-500 h-8 w-8 text-secondary dark:filter-yellow"
                            aria-hidden="true"
                            src="{{ assetsPath$ | async }}/img/purchase-flow-v2/products/single.svg"></ion-icon>
                        <div class="product-info flex-1" aria-hidden="true">
                            <div class="flex-align-center flex justify-between">
                                <p class="product-info__name text-base font-bold leading-5 dark:text-contrast-yellow">
                                    {{ product.name | translateObjectField: 'translation' : translate.currentLang }}
                                </p>
                                <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                                    <span *ngIf="product?.price">
                                        {{ product.price.amount | moneyFormat }}
                                        {{ product.price.currency || currency }}
                                    </span>
                                </p>
                            </div>
                            <p
                                class="pt-2 text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow"
                                *ngIf="product.description && !hideDescription">
                                {{ product.description | translateObjectField: 'translation' : translate.currentLang }}
                            </p>
                            <div
                                class="flex-align-center flex justify-between"
                                *ngIf="env.PURCHASE_FLOW?.SHOW_TICKET_DURATION_DESCRIPTION">
                                <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                                    <span>
                                        {{
                                            ticketDurationDescriptionService.getProductDurationDescription(
                                                product.products[0].activeTicketDurationInMinutes
                                            )
                                        }}
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="flex flex-col justify-center p-2">
                            <ion-icon name="chevron-forward-outline" aria-hidden="true"></ion-icon>
                        </div>
                    </button>
                </ng-container>

                <!-- SINGLE_TICKET_GROUP block -->
                <ng-container *ngSwitchCase="ProductCode.SINGLE_TICKET_GROUP">
                    <ng-container *ngIf="productGroup.products.length">
                        <ng-container
                            *ngTemplateOutlet="
                                productTemplate;
                                context: { group: productGroup, product: productGroup.products[0] }
                            ">
                        </ng-container>
                    </ng-container>
                    <button
                        class="product flex-justify-between flex w-full gap-4 border-t border-solid border-black border-opacity-10 pb-4 pt-4 dark:border-contrast-yellow"
                        *ngFor="let product of productGroup.products?.[0]?.products ?? []"
                        [attr.aria-label]="product.ariaLabel"
                        (click)="presentModal(product.id, productGroup.code)">
                        <ion-icon
                            class="varmland-light:text-secondary-button orebro-light:text-orange-500 h-8 w-8 text-secondary dark:filter-yellow"
                            aria-hidden="true"
                            src="{{ assetsPath$ | async }}/img/purchase-flow-v2/products/single.svg"></ion-icon>
                        <div class="product-info flex-1 text-left" aria-hidden="true">
                            <div class="flex-align-center flex justify-between">
                                <p class="product-info__name text-base font-bold leading-5 dark:text-contrast-yellow">
                                    {{ product.name | translateObjectField: 'translation' : translate.currentLang }}
                                </p>
                                <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                                    <span *ngIf="product?.price">
                                        <ng-container *ngIf="product.price.amount; else priceRange">
                                            {{ product.price.amount | moneyFormat }}
                                        </ng-container>
                                        <ng-template #priceRange>
                                            {{ product.price.minAmount | moneyFormat }} -
                                            {{ product.price.maxAmount | moneyFormat }}
                                        </ng-template>
                                        {{ product.price.currency || currency }}
                                    </span>
                                </p>
                            </div>
                            <p
                                class="pt-2 text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow"
                                *ngIf="product.description && !hideDescription">
                                {{ product.description | translateObjectField: 'translation' : translate.currentLang }}
                            </p>
                            <div
                                class="flex-align-center flex justify-between"
                                *ngIf="env.PURCHASE_FLOW?.SHOW_TICKET_DURATION_DESCRIPTION">
                                <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                                    <span>
                                        {{
                                            ticketDurationDescriptionService.getProductDurationDescription(
                                                product.products[0].activeTicketDurationInMinutes
                                            )
                                        }}
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="flex flex-col justify-center p-2">
                            <ion-icon name="chevron-forward-outline" aria-hidden="true"></ion-icon>
                        </div>
                    </button>
                </ng-container>

                <!-- MULTI_TRIP block -->
                <ng-container *ngSwitchCase="ProductCode.MULTI_TRIP">
                    <ng-container *ngIf="productGroup.products.length">
                        <ng-container
                            *ngTemplateOutlet="
                                productTemplate;
                                context: { group: productGroup, product: productGroup.products[0] }
                            ">
                        </ng-container>
                    </ng-container>
                    <button
                        class="product flex-justify-between flex w-full gap-4 border-t border-solid border-black border-opacity-10 pb-4 pt-4 dark:border-contrast-yellow"
                        *ngFor="let product of productGroup.products"
                        [attr.aria-label]="product.ariaLabel"
                        (click)="presentModal(product.id, productGroup.code)">
                        <ion-icon
                            class="varmland-light:text-secondary-button orebro-light:text-orange-500 logo-category-multi-trip h-8 w-8 text-secondary dark:filter-yellow"
                            aria-hidden="true"
                            src="{{ assetsPath$ | async }}/img/purchase-flow-v2/products/multi_journey.svg"></ion-icon>
                        <div class="product-info flex-1" aria-hidden="true">
                            <div class="flex-align-center flex justify-between">
                                <p class="product-info__name text-base font-bold leading-5 dark:text-contrast-yellow">
                                    {{ product.name | translateObjectField: 'translation' : translate.currentLang }}
                                </p>
                                <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                                    <span *ngIf="product?.price">
                                        {{ product.price.amount | moneyFormat }}
                                        {{ product.price.currency || currency }}
                                    </span>
                                </p>
                            </div>
                            <p
                                class="pt-2 text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow"
                                *ngIf="product.description && !hideDescription">
                                {{ product.description | translateObjectField: 'translation' : translate.currentLang }}
                            </p>
                            <div
                                class="flex-align-center flex justify-between"
                                *ngIf="env.PURCHASE_FLOW?.SHOW_TICKET_DURATION_DESCRIPTION">
                                <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                                    <span>
                                        {{
                                            ticketDurationDescriptionService.getProductDurationDescription(
                                                product.products[0].activeTicketDurationInMinutes
                                            )
                                        }}
                                    </span>
                                </p>
                            </div>
                        </div>
                        <div class="flex flex-col justify-center p-2">
                            <ion-icon name="chevron-forward-outline" aria-hidden="true"></ion-icon>
                        </div>
                    </button>
                </ng-container>

                <!-- PERIOD block -->
                <ng-container *ngSwitchCase="ProductCode.PERIOD">
                    <ng-container *ngIf="periodTypesList.length">
                        <ng-container
                            *ngTemplateOutlet="
                                productTemplate;
                                context: { group: productGroup, product: productGroup.products[0] }
                            ">
                        </ng-container>
                    </ng-container>
                    <ng-container *ngFor="let period of periodTypesList">
                        <button
                            class="product flex-justify-between flex w-full gap-4 border-t border-solid border-black border-opacity-10 pb-4 pt-4 dark:border-contrast-yellow"
                            *ngIf="isShowPeriodTypeItem(categoryProducts[index], period.code)"
                            [attr.aria-label]="period.ariaLabel"
                            (click)="selectProductGroup('productType:' + productGroup.code, 'period:' + period.code)">
                            <ion-icon
                                class="varmland-light:text-secondary-button orebro-light:text-orange-500 h-8 w-8 text-secondary dark:filter-yellow"
                                aria-hidden="true"
                                src="{{ assetsPath$ | async }}/img/purchase-flow-v2/products/period.svg"></ion-icon>
                            <div class="product-info flex-1" aria-hidden="true">
                                <div class="flex-align-center flex justify-between">
                                    <p class="product-info__name text-base font-bold leading-5">
                                        {{ period.name | translateObjectField: 'translation' : translate.currentLang }}
                                    </p>
                                    <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                                        <span>
                                            {{ getPriceByTimeInterval(period.code) | moneyFormat }}
                                            {{ getCurrencyByTimeInterval(period.code) }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="flex flex-col justify-center p-2">
                                <ion-icon title="chevron" name="chevron-forward-outline" aria-hidden="true"></ion-icon>
                            </div>
                        </button>
                    </ng-container>
                </ng-container>

                <!-- PERIOD_PASS block -->
                <ng-container *ngSwitchCase="ProductCode.PERIOD_PASS">
                    <ng-container *ngIf="periodTypesList.length">
                        <ng-container
                            *ngTemplateOutlet="
                                productTemplate;
                                context: { group: productGroup, product: productGroup.products[0] }
                            ">
                        </ng-container>
                    </ng-container>
                    <ng-container *ngFor="let period of periodTypesList">
                        <button
                            class="product flex-justify-between flex w-full gap-4 border-t border-solid border-black border-opacity-10 pb-4 pt-4 dark:border-contrast-yellow"
                            *ngIf="isShowPeriodTypeItem(categoryProducts[index], period.code)"
                            [attr.aria-label]="period.ariaLabel"
                            (click)="selectProductGroup('productType:' + productGroup.code, 'period:' + period.code)">
                            <ion-icon
                                class="varmland-light:text-secondary-button orebro-light:text-orange-500 h-8 w-8 text-secondary dark:filter-yellow"
                                aria-hidden="true"
                                src="{{ assetsPath$ | async }}/img/purchase-flow-v2/products/period.svg"></ion-icon>
                            <div class="product-info flex-1" aria-hidden="true">
                                <div class="flex-align-center flex justify-between">
                                    <p class="product-info__name text-base font-bold leading-5">
                                        {{ period.name | translateObjectField: 'translation' : translate.currentLang }}
                                    </p>
                                    <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                                        <span>
                                            {{ getPriceByTimeInterval(period.code) | moneyFormat }}
                                            {{ getCurrencyByTimeInterval(period.code) }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div class="flex flex-col justify-center p-2">
                                <ion-icon title="chevron" name="chevron-forward-outline" aria-hidden="true"></ion-icon>
                            </div>
                        </button>
                    </ng-container>
                </ng-container>

                <!-- BOOKLET block -->
                <ng-container *ngSwitchCase="ProductCode.BOOKLET">
                    <ng-container *ngIf="env.PURCHASE_FLOW?.BOOKLET_JP_ENABLE">
                        <ng-container
                            *ngTemplateOutlet="
                                productTemplate;
                                context: { group: productGroup, product: productGroup.products[0] }
                            ">
                        </ng-container>
                        <button
                            class="product flex-justify-between flex w-full gap-4 border-t border-solid border-black border-opacity-10 pb-4 pt-4 dark:border-contrast-yellow"
                            [attr.aria-label]="
                                ('BOOKLET' | translate) + ', ' + (priceForBooklet | moneyFormat) + ' ' + bookletCurrency
                            "
                            (click)="selectProductGroup('productType:booklet', 'booklet')">
                            <ion-icon
                                class="varmland-light:text-secondary-button orebro-light:text-orange-500 h-8 w-8 text-secondary dark:filter-yellow"
                                aria-hidden="true"
                                src="{{ assetsPath$ | async }}/img/purchase-flow-v2/products/booklet.svg"></ion-icon>
                            <div class="product-info flex-1" aria-hidden="true">
                                <div class="flex-align-center flex justify-between">
                                    <p class="product-info__name text-base font-bold leading-5">
                                        {{ 'BOOKLET' | translate }}
                                    </p>
                                    <p class="font-normal text-grey-dark dark:text-contrast-yellow">
                                        <span> {{ priceForBooklet | moneyFormat }} {{ bookletCurrency }} </span>
                                    </p>
                                </div>
                            </div>
                            <div class="flex flex-col justify-center p-2">
                                <ion-icon title="chevron" name="chevron-forward-outline" aria-hidden="true"></ion-icon>
                            </div>
                        </button>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>

<ng-template #productTemplate let-productGroup="group" let-product="product">
    <div class="flex items-center justify-between">
        <h1
            class="pb-4 pt-4 text-xs font-bold uppercase leading-7 text-grey-dark dark:text-contrast-yellow"
            [class.normal-case]="env.REMOVE_UPPERCASE">
            {{ 'CATEGORY_PRODUCT_' + productGroup.code.toUpperCase() | translate }}
        </h1>
        <span
            class="text-xs font-normal text-grey-dark dark:text-contrast-yellow"
            *ngIf="product?.price?.amount > 0 && !product?.dynamicLength">
            {{ 'ADULT_PRICE' | translate }}
        </span>
    </div>
</ng-template>
